import React, { useContext } from 'react';
import styled from 'styled-components';
import { Popover } from 'react-tiny-popover';

import ThemeContext from '../../theme/ThemeContext';

import Icon from './Icon';

const StyledPopoverMenu = styled.div`
  z-index: 1000;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.backgroundColor};
  border: ${(props) => `1px solid ${props.theme.borderColor}`};
  border-radius: ${(props) => props.theme.borderRadius}px;
  box-shadow: 0px 1px 10px 1px rgba(20, 20, 23, 0.35);
  font-family: ${(props) => props.theme.fontFamily};
  padding: 3px;
  max-height: 400px;
  overflow-y: auto;
`;

const StyledPopoverMenuItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 12px;
  border-bottom: ${(props) => (props.lastIndex ? '0px' : `1px solid ${(props) => props.theme.borderColor}`)};
  transition: all 0.15s ease-in-out;
  color: ${(props) => props.theme.fontColorPrimary};

  svg {
    color: ${(props) => props.theme.fontColorPrimary};
  }

  &:hover {
    cursor: pointer;
    color: ${(props) => props.theme.primaryColor} !important;
    svg {
      color: ${(props) => props.theme.primaryColor} !important;
    }
  }
`;

const StyledPopoverMenuItemIcon = styled.div`
  margin-right: 8px; 
  svg {
    font-size: 12px;
  }
`;

const StyledPopoverMenuItemText = styled.div`
  font-weight: 500;
  font-size: 12px;
  flex: 1; 
`;

const StyledPopoverMenuItemSubText = styled.div`
  font-size: 12px;
  flex: 1; 
  margin-top: 2px;
  color: ${(props) => props.theme.fontColorSecondary};
`;

const PopoverMenu = ({
  isOpen = false,
  items,
  positions = ['top', 'bottom', 'left'],
  children,
  content,
  header,
  onClickOutside
}) => {

  const theme = useContext(ThemeContext);

  const itemNodes = items && items.length > 0 ? items.map(({ text, subtext, icon, textStyles = {}, subTextStyles = {}, onClick, active }, i) => {
    const lastIndex = i === (items.length - 1);

    if (active) textStyles = { ...textStyles, color: '#005fcc' };

    return (
      <StyledPopoverMenuItem
        key={i}
        theme={theme}
        active={active}
        onClick={(e) => {
          e.stopPropagation();
          if (onClick) onClick();
        }}
        lastIndex={lastIndex}
      >
        {!icon ? null : (<StyledPopoverMenuItemIcon><Icon {...icon} /></StyledPopoverMenuItemIcon>)}
        <div style={{ flexDirection: 'column' }}>
          {!text ? null : (<StyledPopoverMenuItemText theme={theme} style={textStyles}>{text}</StyledPopoverMenuItemText>)}
          {!subtext ? null : (<StyledPopoverMenuItemSubText theme={theme} style={subTextStyles}>{subtext}</StyledPopoverMenuItemSubText>)}
        </div>
      </StyledPopoverMenuItem>
    );
  }) : null;

  return (
    <Popover
      reposition={false}
      isOpen={isOpen}
      positions={positions} // preferred positions by priority
      containerStyle={{ zIndex: 10000 }}
      content={(
        <StyledPopoverMenu theme={theme}>
          {header}
          {itemNodes}
          {content}
        </StyledPopoverMenu>
      )}
      onClickOutside={onClickOutside}
    >
      {children}
    </Popover>
  );

};

export default PopoverMenu;
